/**
 * Detect duplicate-account errors leaked as SQL or returned as API copy.
 */
export function isAccountAlreadyExistsError(message) {
    if (!message || typeof message !== 'string') {
        return false;
    }

    return /kuser_tkt_instances|duplicate key|23505|account_already_exists|email_already_used|compte existe déjà|déjà utilisé|already in use|already used|account already exists|bereits verwendet|bereits ein konto|già in uso|esiste già un account/i.test(message);
}
